// temp fake user id
window.location.hash = 'mik';

var notes = 2;
var countAll = 3;
// var canvas = document.getElementById('drawing');
// let canvasX = 0;
// let canvasY = 0;
// let context = canvas.getContext('2d');

class Nesktop extends HTMLElement {
  constructor() {
    super();

    // Wallpaper
    var imgUrl;
    if(this.hasAttribute('w')) {
      imgUrl = this.getAttribute('w');
    } else {
      imgUrl = '../img/w-default.png';
    }
    this.style = 'background: transparent url('+imgUrl+') center center;'

    // Draggable ref
    this.queen;

    // Listeners
    document.addEventListener("mousedown", this.dragStart, false);
    document.addEventListener("mouseup", this.dragEnd, false);
    document.addEventListener("mousemove", this.drag, false);
  }

  dragStart(e) {
    // console.log('drag start');
    this.queen = e.target;
    console.log(this.queen.localName);
    if (e.type === "touchstart") {
      this.queen.initialX = e.touches[0].clientX - this.queen.xOffset;
      this.queen.initialY = e.touches[0].clientY - this.queen.yOffset;
    } else {
      this.queen.initialX = e.clientX - this.queen.xOffset;
      this.queen.initialY = e.clientY - this.queen.yOffset;
    }

    this.queen.active = true;
    this.queen.style.zIndex = countAll;
    this.queen.classList.add('queen');
  }

  dragEnd(e) {
    this.queen.initialX = this.queen.currentX;
    this.queen.initialY = this.queen.currentY;

    this.queen.active = false;
    this.queen.style.zIndex = 'auto';
    this.queen.classList.remove('queen');

    this.queen = undefined;
  }

  drag(e) {
    if (this.queen !== undefined && this.queen.localName == 'nesk-note') {

      e.preventDefault();

      if (e.type === "touchmove") {
        this.queen.currentX = e.touches[0].clientX - this.queen.initialX;
        this.queen.currentY = e.touches[0].clientY - this.queen.initialY;
      } else {
        this.queen.currentX = e.clientX - this.queen.initialX;
        this.queen.currentY = e.clientY - this.queen.initialY;
      }

      this.queen.xOffset = this.queen.currentX;
      this.queen.yOffset = this.queen.currentY;

      this.queen.style.transform = "translate3d(" + this.queen.currentX + "px, " + this.queen.currentY + "px, 0)";

    // } else if (this.queen !== undefined && this.queen.localName == 'canvas') {
    //
    //   context.beginPath();
    //   context.strokeStyle = 'black';
    //   context.lineWidth = 1;
    //   context.moveTo(canvasX, canvasY);
    //   context.lineTo(e.offsetX, e.offsetY);
    //   context.stroke();
    //   context.closePath();
    //   canvasX = e.offsetX;
    //   canvasY = e.offsetY;

    }

  }

}

// class Drawing extends HTMLCanvasElement {
//
//   constructor() {
//     super();
//     this.currentX = 0;
//     this.currentY = 0;
//   }
//
// }

class Draggable extends HTMLElement {

  constructor() {
    super();
    this.active = false;
    this.currentX;
    this.currentY;
    this.initialX;
    this.initialY;
    this.xOffset = 0;
    this.yOffset = 0;
  }

}

class Note extends Draggable {
  constructor() {
    super();
    // this.style = 'border: 1px solid red;'
  }
}

customElements.define('nesk-top', Nesktop);
// customElements.define('nesk-drawing', Drawing);
customElements.define('nesk-note', Note);


// When true, moving the mouse draws on the canvas
let isDrawing = false;
let x = 0;
let y = 0;

const drawing = document.getElementById('drawing');
const context = drawing.getContext('2d');

window.addEventListener('resize', resizeCanvas, false);

function resizeCanvas() {
  drawing.width = window.innerWidth;
  drawing.height = window.innerHeight;

  // Add the event listeners for mousedown, mousemove, and mouseup
  drawing.addEventListener('mousedown', e => {
    x = e.offsetX;
    y = e.offsetY;
    isDrawing = true;
  });

  drawing.addEventListener('mousemove', e => {
    if (isDrawing === true) {
      console.log('draw');
      drawLine(context, x, y, e.offsetX, e.offsetY);
      x = e.offsetX;
      y = e.offsetY;
    }
  });

  window.addEventListener('mouseup', e => {
    if (isDrawing === true) {
      drawLine(context, x, y, e.offsetX, e.offsetY);
      x = 0;
      y = 0;
      isDrawing = false;
    }
  });

}

resizeCanvas();

function drawLine(context, x1, y1, x2, y2) {
  context.beginPath();
  context.strokeStyle = 'black';
  context.lineWidth = 1;
  context.moveTo(x1, y1);
  context.lineTo(x2, y2);
  context.stroke();
  context.closePath();
}


    // container.addEventListener("touchstart", dragStart, false);
    // container.addEventListener("touchend", dragEnd, false);
    // container.addEventListener("touchmove", drag, false);
